import React from 'react';
import './AchievementBadge.scss';

const AchievementBadge = ({ name, description, picture }) => {
  return (
    <div className="achievement-badge">
      <img alt="achievement-logo" src={picture} />
      <h1>{name}</h1>
      <p>{description}</p>
    </div>
  );
};

export { AchievementBadge };


// WEBPACK FOOTER //
// ./src/components/AchievementBadge.js